/**
 * Woodluxe Color Picker
 * Fetches colors from 'woodluxe_color' metaobject via GraphQL Storefront API
 */
document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('wl-picker-modal');
  if (!modal) return; // Exit if picker not on page
  
  // Move modal to body for proper z-index stacking
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
  
  const openBtn = document.getElementById('wl-open-picker-btn');
  const closeBtn = document.getElementById('wl-close-modal');
  const grid = document.getElementById('wl-colors-grid');
  const searchInput = document.getElementById('wl-search-input');
  const familyButtonsContainer = document.getElementById('wl-family-buttons');
  const colorCountEl = document.getElementById('wl-color-count');
  const paginationEl = document.getElementById('wl-pagination');
  
  const selectedSwatch = document.getElementById('wl-selected-swatch');
  const selectedName = document.getElementById('wl-selected-name');
  const hiddenInput = document.getElementById('wl-stain-color-input');
  
  let allColors = [];
  let filteredColors = [];
  let families = new Set();
  let currentFamily = '';
  let currentPage = 1;
  const ITEMS_PER_PAGE = 75;

  // Open Modal
  openBtn.addEventListener('click', function() {
    modal.classList.add('open');
  });

  // Close Modal
  closeBtn.addEventListener('click', function() {
    modal.classList.remove('open');
  });

  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      modal.classList.remove('open');
    }
  });

  // GraphQL Configuration
  const STOREFRONT_API_TOKEN = '6350a25f484c872c580b9f30d80e7fb8';
  const SHOP_DOMAIN = window.location.hostname;
  const GRAPHQL_ENDPOINT = `https://${SHOP_DOMAIN}/api/2024-01/graphql.json`;

  // Load Colors from GraphQL API
  async function loadColors() {
    try {
      grid.innerHTML = '<div class="bm-loading">Loading colors...</div>';
      
      allColors = [];
      let hasNextPage = true;
      let cursor = null;
      
      // Fetch all pages (should only be 1 page for 75 colors)
      while (hasNextPage) {
        const query = `
          query GetWoodluxeColors($after: String) {
            metaobjects(type: "woodluxe_color", first: 250, after: $after) {
              edges {
                node {
                  fields {
                    key
                    value
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        `;
        
        const variables = cursor ? { after: cursor } : {};
        
        const response = await fetch(GRAPHQL_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
          },
          body: JSON.stringify({ query, variables })
        });
        
        if (!response.ok) {
          throw new Error(`GraphQL request failed: ${response.status} ${response.statusText}`);
        }
        
        const result = await response.json();
        
        if (result.errors) {
          throw new Error(`GraphQL errors: ${JSON.stringify(result.errors)}`);
        }
        
        const metaobjects = result.data.metaobjects;
        
        // Process each metaobject
        metaobjects.edges.forEach(edge => {
          const fields = edge.node.fields;
          const color = {};
          
          fields.forEach(field => {
            color[field.key] = field.value;
          });
          
          allColors.push(color);
        });
        
        hasNextPage = metaobjects.pageInfo.hasNextPage;
        cursor = metaobjects.pageInfo.endCursor;
      }
      
      console.log(`✓ Loaded ${allColors.length} Woodluxe colors`);
      
      if (allColors.length === 0) {
        grid.innerHTML = '<div class="bm-loading">No colors available. Please ensure woodluxe_color metaobjects are created.</div>';
        return;
      }
      
      // Extract families
      families.clear();
      allColors.forEach(color => {
        if (color.family) {
          families.add(color.family);
        }
      });
      
      window.WoodluxeColors = { colors: allColors, loaded: true };
      
      renderFamilyButtons();
      renderColors(allColors);
      
    } catch (error) {
      console.error('Error loading Woodluxe colors:', error);
      grid.innerHTML = '<div class="bm-loading">Error loading colors: ' + error.message + '</div>';
    }
  }

  // Family colors mapping
  const familyColors = {
    'Black': '#222222',
    'Blue': '#1e40af',
    'Brown': '#5c3310',
    'Gray': '#4b5563',
    'Green': '#047857',
    'Neutral': '#a58d75',
    'Natural': '#d4a574',
    'Orange': '#b45309',
    'Red': '#b91c1c',
    'White': '#f3f4f6',
    'Yellow': '#ffcf30'
  };

  function getContrastColor(hexColor) {
    if (!hexColor || hexColor.length < 7) return '#000000';
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }

  function renderFamilyButtons() {
    familyButtonsContainer.innerHTML = '';
    
    if (families.size === 0) return;
    
    const row = document.createElement('div');
    row.className = 'bm-family-row bm-family-row--colors';
    
    // Add "All" button
    const allBtn = document.createElement('button');
    allBtn.className = 'bm-family-btn' + (currentFamily === '' ? ' active' : '');
    allBtn.textContent = 'All';
    allBtn.style.backgroundColor = '#e5e7eb';
    allBtn.style.color = '#000000';
    allBtn.dataset.family = '';
    allBtn.addEventListener('click', () => selectFamily(''));
    row.appendChild(allBtn);

    // Add family buttons
    const sortedFamilies = Array.from(families).sort();
    sortedFamilies.forEach(family => {
      const btn = document.createElement('button');
      btn.className = 'bm-family-btn' + (currentFamily === family ? ' active' : '');
      const colorBg = familyColors[family] || '#9ca3af';
      const textColor = getContrastColor(colorBg);
      btn.textContent = family;
      btn.style.backgroundColor = colorBg;
      btn.style.color = textColor;
      btn.dataset.family = family;
      btn.addEventListener('click', () => selectFamily(family));
      row.appendChild(btn);
    });
    
    familyButtonsContainer.appendChild(row);
  }

  function selectFamily(family) {
    currentFamily = family;
    currentPage = 1;
    renderFamilyButtons();
    filterColors();
  }

  function filterColors() {
    const searchTerm = searchInput.value.toLowerCase();
    
    let filtered = allColors.filter(color => {
      const matchesSearch = color.name.toLowerCase().includes(searchTerm) || 
                            color.code.toLowerCase().includes(searchTerm);
      const matchesFamily = currentFamily === '' || color.family === currentFamily;
      return matchesSearch && matchesFamily;
    });
    
    // Sort by color code
    filtered.sort((a, b) => {
      const codeA = (a.code || '').toUpperCase();
      const codeB = (b.code || '').toUpperCase();
      return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
    });
    
    renderColors(filtered);
  }

  function renderColors(colors) {
    filteredColors = colors;
    currentPage = 1;
    renderPage();
    renderPagination();
  }
  
  function renderPage() {
    grid.innerHTML = '';
    
    if (colorCountEl) {
      colorCountEl.textContent = `Found ${filteredColors.length} color${filteredColors.length !== 1 ? 's' : ''}`;
    }
    
    if (filteredColors.length === 0) {
      grid.innerHTML = '<div class="bm-loading">No colors found matching your criteria.</div>';
      paginationEl.innerHTML = '';
      return;
    }
    
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, filteredColors.length);
    const pageColors = filteredColors.slice(startIndex, endIndex);
    
    const fragment = document.createDocumentFragment();

    pageColors.forEach(color => {
      const item = document.createElement('div');
      item.className = 'bm-color-item';
      item.dataset.name = color.name;
      item.dataset.code = color.code;
      item.dataset.hex = color.hex;
      
      const textColor = getContrastColor(color.hex);
      item.innerHTML = `
        <div class="bm-color-preview" style="background-color: ${color.hex}; color: ${textColor};">
          <div class="bm-color-info">
            <span class="bm-color-code">${color.code}</span>
            <span class="bm-color-name">${color.name}</span>
          </div>
        </div>
      `;
      
      const pickerContainer = document.querySelector('.woodluxe-color-picker');
      const isBrowseMode = pickerContainer && pickerContainer.dataset.mode === 'browse';

      if (!isBrowseMode) {
        item.style.cursor = 'pointer';
        item.addEventListener('click', () => selectColor(color));
      } else {
        item.style.cursor = 'default';
      }
      
      fragment.appendChild(item);
    });
    
    grid.appendChild(fragment);
  }
  
  function renderPagination() {
    const totalPages = Math.ceil(filteredColors.length / ITEMS_PER_PAGE);
    
    if (totalPages <= 1) {
      paginationEl.innerHTML = '';
      return;
    }
    
    let html = '';
    html += `<button ${currentPage === 1 ? 'disabled' : ''} onclick="wlChangePage(${currentPage - 1})">← Previous</button>`;
    
    for (let i = 1; i <= totalPages; i++) {
      html += `<button class="${i === currentPage ? 'active' : ''}" onclick="wlChangePage(${i})">${i}</button>`;
    }
    
    html += `<button ${currentPage === totalPages ? 'disabled' : ''} onclick="wlChangePage(${currentPage + 1})">Next →</button>`;
    
    paginationEl.innerHTML = html;
  }
  
  window.wlChangePage = function(page) {
    currentPage = page;
    renderPage();
    renderPagination();
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  function selectColor(color) {
    if (selectedSwatch) selectedSwatch.style.backgroundColor = color.hex;
    if (selectedName) selectedName.textContent = `${color.name} (${color.code})`;
    if (hiddenInput) hiddenInput.value = `${color.name} (${color.code})`;
    modal.classList.remove('open');
    
    // Remove error state when color is selected
    const container = document.querySelector('.woodluxe-color-picker');
    if (container) {
      container.classList.remove('color-required-error');
      
      // Update Shop Pay buttons state
      updateWoodluxeShopPayState();
    }
    
    // Trigger change event
    if (hiddenInput) {
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Update Shop Pay / Accelerated Checkout button state based on BOTH color and checkbox
  function updateWoodluxeShopPayState() {
    const shopifyPaymentContainer = document.querySelector('.shopify-payment-button');
    
    // Check if color is selected
    const pickerContainer = document.querySelector('.woodluxe-color-picker');
    let colorValid = true;
    if (pickerContainer) {
      const style = window.getComputedStyle(pickerContainer);
      const isVisible = style.display !== 'none';
      const hiddenInputVal = document.getElementById('wl-stain-color-input');
      const hasColor = hiddenInputVal && hiddenInputVal.value && hiddenInputVal.value.trim() !== '';
      colorValid = !isVisible || hasColor; // Valid if picker is hidden OR color is selected
    }
    
    // Check if checkbox is checked (agree condition)
    const agreeCheckbox = document.querySelector('.accelerated-checkout-block .checkbox__input');
    const checkboxValid = !agreeCheckbox || agreeCheckbox.checked;
    
    // Both must be valid to enable
    const enabled = colorValid && checkboxValid;
    
    if (shopifyPaymentContainer) {
      if (enabled) {
        shopifyPaymentContainer.classList.remove('disabled');
        shopifyPaymentContainer.style.pointerEvents = '';
        shopifyPaymentContainer.style.opacity = '';
      } else {
        shopifyPaymentContainer.classList.add('disabled');
        shopifyPaymentContainer.style.pointerEvents = 'none';
        shopifyPaymentContainer.style.opacity = '0.5';
      }
    }
  }

  // Validation: Make color selection mandatory
  function validateWoodluxeColorSelection() {
    const pickerContainer = document.querySelector('.woodluxe-color-picker');
    if (!pickerContainer) return true;
    
    // Check for browse mode
    if (pickerContainer.dataset.mode === 'browse') {
      return true;
    }
    
    // Check if picker is visible
    const style = window.getComputedStyle(pickerContainer);
    if (style.display === 'none') {
      pickerContainer.classList.remove('color-required-error');
      return true;
    }

    // If picker is visible, check if a color is selected
    const hiddenInputVal = document.getElementById('wl-stain-color-input');
    const colorValue = hiddenInputVal ? hiddenInputVal.value : '';
    
    if (!colorValue || colorValue.trim() === '') {
      console.log('[Woodluxe Picker] ✗ No color selected');
      
      // Show error state
      pickerContainer.classList.add('color-required-error');
      
      // Scroll to color picker
      pickerContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      return false;
    }
    
    pickerContainer.classList.remove('color-required-error');
    return true;
  }
  
  // Expose validation function globally
  window.validateWoodluxeColor = validateWoodluxeColorSelection;
  
  // Intercept Buy Now / Shop Pay buttons
  function setupWoodluxeBuyNowValidation() {
    function addInterceptor(button) {
      if (button.dataset.wlIntercepted) return;
      button.dataset.wlIntercepted = 'true';
      
      button.addEventListener('click', function(e) {
        // Check color selection
        if (!validateWoodluxeColorSelection()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('[Woodluxe Picker] Color selection is required - blocked');
          return false;
        }
        
        // Check checkbox (agree condition)
        const agreeCheckbox = document.querySelector('.accelerated-checkout-block .checkbox__input');
        if (agreeCheckbox && !agreeCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const checkboxContainer = agreeCheckbox.closest('.newsletter-form__checkbox');
          if (checkboxContainer) {
            checkboxContainer.classList.add('checkbox-required-error');
            checkboxContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          
          console.log('[Woodluxe Picker] Checkbox agreement is required - blocked');
          return false;
        }
      }, true);
    }
    
    // Add interceptors to existing buttons
    const shopifyPaymentButtons = document.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button button');
    shopifyPaymentButtons.forEach(addInterceptor);
    
    // Initial state update
    updateWoodluxeShopPayState();
    
    // Listen to checkbox changes
    const agreeCheckboxEl = document.querySelector('.accelerated-checkout-block .checkbox__input');
    if (agreeCheckboxEl) {
      agreeCheckboxEl.addEventListener('change', function() {
        updateWoodluxeShopPayState();
      });
    }
    
    // Use MutationObserver to catch dynamically added payment buttons
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.matches && (node.matches('.shopify-payment-button__button') || node.matches('.shopify-payment-button button'))) {
              addInterceptor(node);
            }
            const buttons = node.querySelectorAll ? node.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button button') : [];
            buttons.forEach(addInterceptor);
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Add click interceptor on payment button container
    const paymentContainer = document.querySelector('.shopify-payment-button');
    if (paymentContainer) {
      paymentContainer.addEventListener('click', function(e) {
        if (!validateWoodluxeColorSelection()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
        
        const agreeCheckbox = document.querySelector('.accelerated-checkout-block .checkbox__input');
        if (agreeCheckbox && !agreeCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const checkboxContainer = agreeCheckbox.closest('.newsletter-form__checkbox');
          if (checkboxContainer) {
            checkboxContainer.classList.add('checkbox-required-error');
            checkboxContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return false;
        }
      }, true);
    }
  }
  
  // Initialize validation after delay
  function initWoodluxeValidation() {
    setupWoodluxeBuyNowValidation();
  }
  
  setTimeout(initWoodluxeValidation, 500);

  // Debounce search
  let timeout = null;
  searchInput.addEventListener('input', function() {
    clearTimeout(timeout);
    timeout = setTimeout(filterColors, 300);
  });

  // Load colors on page load
  loadColors();
});
